import { toast } from "react-toastify";
import { API_path } from "./apiPath";
import axiosInstance from "./axios";

const getOrdersReport = async (branchId) => {
  let resOrdersReport = [];
  try {
    const response = await axiosInstance.get(API_path.getOrdersReport, {
      params: {
        branchId: branchId,
      },
    });
    const responseDate = response.data;
    if (responseDate && responseDate.status) {
      // toast.success(responseDate.paramObjectsMap.message);
      resOrdersReport = responseDate.paramObjectsMap.orderReport;
    } else {
      toast.error(responseDate.paramObjectsMap.errorMessage);
    }
  } catch (error) {
    console.log(error);
  }
  return resOrdersReport;
};


export { getOrdersReport };
